import React from "react";
import { Box } from "@mui/material";
import { Stack, Typography } from "@mui/joy";
import { theme } from "styles/theme";
import SelectCheckbox from "components/onboarding/SelectCheckBox";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";
import { usePromotionOnboardingTracking } from "../../../../hooks/usePromotionOnboardingTracking";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

interface Option {
  id: number;
  text: string;
}

// 옵션 리스트
export const motivation8OptionList: Option[] = [
  { id: 1, text: "배우자/연인" },
  { id: 2, text: "부모/자식" },
  { id: 3, text: "인간관계" },
  { id: 4, text: "경력" },
  { id: 5, text: "배움" },
  { id: 6, text: "여가" },
  { id: 7, text: "종교" },
  { id: 8, text: "사회 기여" },
  { id: 9, text: "기타" },
];

export default function Motivation_8_V6({
  hideNextButton,
  version = "v6",
}: {
  hideNextButton: boolean;
  version?: MktVersionTypes;
}) {
  const pageKey = "motivation_8"; // 페이지를 구분할 키 값

  const { multiSelectionIdList, updateMultiSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: `/${versionToPathPrefix(version)}-onboarding/motivation/10`,
    });

  const { trackMultiSelection } = usePromotionOnboardingTracking(pageKey, version);


  const handleOptionChange = (optionId: number) => {
    updateMultiSelection(optionId);
  };

  const handleNextClick = () => {
    trackMultiSelection(multiSelectionIdList);
    handleNext();
  };

  return (
    // ➊ 내용이 버튼 뒤에 가려지지 않도록 충분한 패딩을 줍니다.
    <Stack
      spacing={5}
      sx={{ paddingBottom: "120px" }} // 하단 버튼 높이보다 넉넉하게
    >
      <Typography
        variant="Subtitle"
        fontWeight={500}
        sx={{ color: theme.vars.palette.Content.Strong }}
      >
        {"건강한 마음을 갖는 것 외에, 내 삶에서 중요한 것은 무엇인가요?"}
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {motivation8OptionList.map((option) => (
          <SelectCheckbox
            key={option.id}
            checked={multiSelectionIdList.includes(option.id)}
            onChange={() => handleOptionChange(option.id)}
            label={option.text}
          />
        ))}
      </Box>

      {!hideNextButton && (
        <BottomNextButtonTmp
          disabled={multiSelectionIdList.length === 0}
          onClick={handleNextClick}
          text={"다음"}
        />
      )}
    </Stack>
  );
}
